export function generateRandomId({
  length = 12,
  prefix = '',
  suffix = '',
} = {}): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const id = [...Array(length).keys()]
    .map(() => characters.charAt(Math.floor(Math.random() * characters.length)))
    .join('');
  return prefix + id + suffix;
}
